import moment from 'moment';

import FG677Icon from '../../../../../assets/icons/677fg-icon.svg';
import IgreeksIcon from '../../../../../assets/icons/igreeks-white.svg';
import BinanceIcon from '../../../../../assets/icons/binance-icon.svg';
import BybitIcon from '../../../../../assets/bybit-dark-logo.svg';
import DeribitIcon from '../../../../../assets/icons/deribit-icon.svg';
import OKXIcon from '../../../../../assets/icons/okx-icon.svg';
import OTCIcon from '../../../../../assets/icons/otc-icon.svg';
import { ITableCols } from '../types';

const iconMap: { [key: string]: any } = {
  deribit: DeribitIcon,
  okx: OKXIcon,
  binance: BinanceIcon,
  bybit: BybitIcon,
  otc: OTCIcon,
  '677fg': FG677Icon,
  igreeks: IgreeksIcon,
};

export const strikeReportFlattenColumns = (
  cols: ITableCols[],
  expandedCols: string[],
  level: number = 0,
): ITableCols[] => {
  let result: ITableCols[] = [];
  const isLevelZero = level === 0;

  for (const col of cols) {
    col.level = level;

    if (isLevelZero) {
      const parsed = moment(col.label, 'DDMMMYY', true);
      if (parsed.isValid()) {
        col.label = parsed.format('DD-MMM-YYYY').toUpperCase();
      }
    }

    if (isLevelZero && Array.isArray(col.children) && col.children.length > 0) {
      col.venueIcons = col.children.reduce((acc: { [key: string]: any }, child: any) => {
        const labelLower = child.label.toLowerCase();
        if (iconMap[labelLower]) {
          acc[child.label] = iconMap[labelLower];
        }
        return acc;
      }, {});
    }

    if (level === 1) {
      const labelLower = col.label.toLowerCase();
      col.icon = iconMap[labelLower] || null;
    }

    result.push(col);

    const hasChildren = col.children && col.children.length > 0;
    const isExpanded = expandedCols.includes(col.id);

    if (hasChildren && isExpanded && col.children) {
      result = result.concat(strikeReportFlattenColumns(col.children, expandedCols, level + 1));
    }
  }

  return result;
};
